import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowRight, ChatCircleDots } from "@phosphor-icons/react";

export const QuestionsCta = () => {
  const { t } = useTranslation();

  return (
    <section
      data-testid="programme-questions"
      className="-mt-16 md:-mt-24 pb-20 md:pb-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div
          data-testid="questions-card"
          className="relative overflow-hidden rounded-3xl border border-slate-200 bg-slate-50 px-8 py-10 md:px-12 md:py-12 flex flex-col md:flex-row md:items-center md:justify-between gap-8"
        >
          <div
            className="absolute -top-24 -right-24 h-64 w-64 rounded-full adonis-gradient opacity-20 blur-3xl pointer-events-none"
            aria-hidden="true"
          />

          <div className="relative flex items-start gap-5 max-w-2xl">
            <div className="hidden sm:inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl adonis-gradient shadow-lg shadow-[#7B61FF]/25">
              <ChatCircleDots size={22} weight="light" className="text-white" />
            </div>
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
                {t("programme.questions.kicker")}
              </p>
              <h3 className="mt-3 font-heading text-2xl md:text-3xl font-bold tracking-tight text-slate-900 leading-tight">
                {t("programme.questions.title")}
              </h3>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-slate-600">
                {t("programme.questions.subtitle")}
              </p>
            </div>
          </div>

          <Link
            to="/contact"
            data-testid="questions-cta-btn"
            className="group relative shrink-0 inline-flex items-center justify-center gap-2 rounded-full bg-slate-900 px-7 py-4 text-sm font-medium text-white transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-slate-900/20"
          >
            {t("programme.questions.cta")}
            <ArrowRight
              size={16}
              weight="bold"
              className="transition-transform group-hover:translate-x-1"
            />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default QuestionsCta;
